<template>
  <div>
    <div class="uk-width-xxlarge uk-margin-auto">
      <div v-if="refunds.length" class="uk-alert-warning" uk-alert>
        <div class="uk-text-center">
          <p>
            Refund was already requested for this appointment.<br>
            Please consider the amount that was requested already, while requesting additional refund.
            <u>Recommended maximum amount for refund is: <b>£{{ recommendedMaximumValue }}</b></u>
          </p>
          <div class="uk-margin-remove-bottom refunds">
            <p>List of requested refunds: </p>
            <div v-for="(refund, index) in refunds" :key="index" class="refund">
              <p>Amount: <b>£{{ (refund.value/100).toFixed(2) }}</b></p>
              <p>Reason: {{ refund.reason }}</p>
              <p>Date: {{ $moment(refund.date.seconds, 'X').format('DD/MM/YYYY - HH:mm:ss') }}</p>
              <p>Status: <span style="text-transform: capitalize;">{{ refund.status }}</span></p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="uk-card uk-card-default uk-width-large uk-margin-auto">
      <div class="uk-card-header uk-text-center">
        <h3 class="uk-card-title">Refund Request</h3>
      </div>

      <div class="uk-card-body">
        <ValidationObserver ref="observer" tag="div" class="uk-form-stacked">
          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <label class="uk-form-label" for="reason" :class="{ 'uk-text-danger': errors.length }">Reason</label>
              <div class="uk-form-controls">
                <textarea id="reason" v-model="reason" class="uk-textarea" :class="{ 'uk-form-danger': errors.length }" rows="3" name="reason" />
              </div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>

          <div class="uk-margin">
            <ValidationProvider v-slot="{ errors }" :rules="{ required: true, min_value: 0, max_value: amount }">
              <label class="uk-form-label" for="value" :class="{ 'uk-text-danger': errors.length }">Value</label>
              <div class="uk-form-controls">
                <currency-input ref="value" v-model="value" currency="GBP" :value-range="{ min: 0, max: amount }" class="uk-input" />
              </div>
              <div v-if="recommendedMaximumCheck" class="form-warning">Recommended maximum amount for refund is: <b>£{{ recommendedMaximumValue }}</b></div>
              <div v-if="errors.length" class="form-error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
        </ValidationObserver>
      </div>

      <div class="uk-card-footer uk-text-center">
        <button class="uk-button uk-button-primary uk-margin-small-right" @click="submit()">Submit</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { CurrencyInput, parseCurrency } from 'vue-currency-input'

export default {
  name: 'ComponentRefund',

  components: {
    ValidationProvider,
    ValidationObserver,
    CurrencyInput
  },

  props: {
    amount: {
      type: String,
      required: true,
      default: '99.99'
    },
    refunds: {
      type: Array,
      required: false,
      default() {
        return []
      }
    }
  },

  data() {
    return {
      value: null,
      reason: null
    }
  },

  computed: {
    recommendedMaximumValue() {
      return (parseInt(this.amount, 10) - (this.refunds.reduce((a, { value }) => a + value, 0) / 100)).toFixed(2)
    },

    recommendedMaximumCheck() {
      return this.value > this.recommendedMaximumValue
    }
  },

  methods: {
    submit() {
      const value = parseCurrency(this.$refs.value.formattedValue, { currency: 'GBP', valueAsInteger: true })
      this.$bus.$emit('refund', { value, reason: this.reason })
    }
  }
}
</script>

<style lang="scss" scoped>
.refunds {
  .refund {
    &:not(:last-of-type) {
      position: relative;
      margin-bottom: 1em;
      padding-bottom: 1em;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 100px;
        height: 1px;
        transform: translateX(-50%);
        background-color: $colour-dark;
      }
    }

    p {
      margin: 0;
    }
  }
}
</style>
